import { render, staticRenderFns } from "./TabsItem.vue?vue&type=template&id=e85ef97a&"
import script from "./TabsItem.vue?vue&type=script&lang=js&"
export * from "./TabsItem.vue?vue&type=script&lang=js&"
import style0 from "./TabsItem.vue?vue&type=style&index=0&id=e85ef97a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports